import React from "react";
import { Link, Typography } from "@one-thd/sui-atomic-components";
import { Refresh } from "@one-thd/sui-icons";
import { PAINT_PURCHASE_HISTORY_LINK } from "../../constants/links";
import { PaintUtils } from "../../utils/paint";

export const ErrorLoading = ({ reload }: { reload: () => void }) => {
  const onClick = () => {
    PaintUtils.redirect(PAINT_PURCHASE_HISTORY_LINK);
  };

  return (
    <div data-testid="error-loading">
      <header data-testid="error-header">
        <Typography variant="h3">Paint Purchase History</Typography>
      </header>

      <div className="sui-flex sui-flex-col sui-justify-center sui-items-center sui-h-[325px]">
        <Typography weight="regular">Something went wrong.</Typography>
        <Typography weight="regular">We couldn&apos;t load your information.</Typography>

        <div data-testid="refresh-icon" className="sui-pt-6 sui-pb-2">
          <Refresh size="large" />
        </div>

        <div className="sui-pb-4">
          <Link data-testid="error-refresh-link" onClick={() => reload()}>
            Refresh
          </Link>
        </div>

        <Typography weight="regular">
          Or view your{" "}
          <Link data-testid="error-paint-history-link" onClick={onClick}>
            Paint Purchase History
          </Link>
        </Typography>
      </div>
    </div>
  );
};
